import { createSelector } from 'reselect'

import { ROLES } from 'constants/enums'

const meh = (actions, activeRole) => ({
  actions,
  activeRole
})
const filterByRole = ({ actions, activeRole }) => {
  return actions.filter(item => {
    if (!item.roles) {
      return item
    }
    return item.roles.some(
      actionRole => actionRole === activeRole || actionRole === ROLES.ALL.u
    )
  })
}

export default createSelector(meh, filterByRole)
